// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LA NUBE · UN DESPLEGABLE ABIERTO SE CIERRA SOLO (1-oct-2026, B-1015)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «cuando pulsas sobre el menú que indica el espacio disponible en /nube que si pulso fuera u otro menú se
//  cierre directamente». El desplegable del espacio solo se cerraba volviendo a pulsar su barra: se quedaba abierto
//  encima de la lista mientras se trabajaba, y abierto a la vez que el menú de los tres puntos de una fila.
//
//  LA MISMA REGLA QUE EL MENÚ DE LOS TRES PUNTOS (components/nube/MenuNube.jsx), en un solo sitio para el que no va en
//  un portal: mientras está abierto, se cierra
//   · al PULSAR o TOCAR fuera de él (también sobre otro menú: abrir otro lo cierra);
//   · con ESCAPE (y esa tecla no sigue hacia los atajos de la pantalla);
//   · cuando el FOCO se va fuera (abrir otro menú con el teclado, tabular a otra cosa);
//   · al ir ATRÁS o ADELANTE en el navegador (cambia la pantalla o la carpeta).
//  `dentro(elemento)` dice si un elemento es del desplegable (o de su botón); `cerrar(motivo)` lo cierra. Devuelve la
//  función que quita los oyentes. Sin `document` (una guardia, el servidor) no engancha nada.
//
//  PURO: ni React ni estado. Lo mide backend/routes/nube-desplegables-se-cierran.test.js con un documento de mentira.
export function engancharCierre({ dentro, cerrar, doc = typeof document !== 'undefined' ? document : null, win = typeof window !== 'undefined' ? window : null } = {}) {
  if (!doc || typeof doc.addEventListener !== 'function' || typeof cerrar !== 'function') return () => {}
  const esDentro = (t) => { try { return !!(dentro && dentro(t)) } catch (_) { return false } }
  const fuera = (e) => { if (!esDentro(e && e.target)) cerrar('fuera') }
  const tecla = (e) => {
    if (!e || e.key !== 'Escape') return
    if (e.stopPropagation) e.stopPropagation()
    cerrar('escape')
  }
  const foco = (e) => { if (!esDentro(e && e.target)) cerrar('foco') }
  const ruta = () => cerrar('ruta')
  doc.addEventListener('mousedown', fuera, true)
  doc.addEventListener('touchstart', fuera, true)
  doc.addEventListener('keydown', tecla, true)
  doc.addEventListener('focusin', foco, true)
  const conVentana = !!(win && typeof win.addEventListener === 'function')
  if (conVentana) win.addEventListener('popstate', ruta)
  return () => {
    doc.removeEventListener('mousedown', fuera, true)
    doc.removeEventListener('touchstart', fuera, true)
    doc.removeEventListener('keydown', tecla, true)
    doc.removeEventListener('focusin', foco, true)
    if (conVentana) win.removeEventListener('popstate', ruta)
  }
}
